/**
 * App version — bumped by one minor step on every push to GitHub.
 * Displayed at the bottom of the sidebar.
 */
export const APP_VERSION = '2.62'
